define('tracking',['utils/constants', 'utils/uri_helper'],function(CONST, Helper){
  return {
    track: function(client_id, params){
      var html, body, iframe, url = Helper.appendToUrl(CONST.tracking_url, params);
      url = Helper.appendToUrl(url, {client_id: client_id});
      body = document.getElementsByTagName('body')[0];
      if (document.attachEvent){
        html = (
          '<iframe' +
          ' style="border:none;overflow:hidden;display:none;"' +
          ' src="javascript:false;"' +
          '></iframe>'
          );
        iframe = document.createElement(html);
        body.appendChild(iframe);
        iframe.src = url;
      }
      else {
        iframe = document.createElement('iframe');
        iframe.style.border = 'none';
        iframe.style.overflow = 'hidden';
        iframe.style.display = 'none';
        iframe.src = url;
        body.appendChild(iframe);
      }
      // Removes the iframe after 2500 ms
      setTimeout(function(){
        if (iframe.parentNode){
          iframe.parentNode.removeChild(iframe);
        }
      }, 2500);

    }
  }


});

